export default __webpack_public_path__ + "static/media/9.a5f2d56e.jpeg";